import { Component, OnInit } from '@angular/core';
import { OrderStateService } from '../../../order/services/order-state.service';
import { Order } from '../../../order/models/order';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { Partner } from '../../../partner/models/partner';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-kiosk-order-complete',
  templateUrl: './kiosk-order-complete.component.html',
  styleUrls: ['./kiosk-order-complete.component.css']
})
export class KioskOrderCompleteComponent implements OnInit {

  constructor(
    private orderStateService: OrderStateService,
    private kioskStateService: KioskStateService,
    private partnerStateService: PartnerStateService,
  ) { }

  ngOnInit() {
  }

  get order(): Order {
    return this.orderStateService.order;
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  get guestOfHonor(): Partner {
    return this.kioskStateService.guestOfHonor;
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  complete() {
    this.kioskStateService.update(KioskStateEnum.ThankYou);
  }

}
